export default "__VITE_ASSET__DTvxHwP6__";